import qs from 'qs'

const fields = [
  'invertTextOnHomepage',
  'locale',
  'slug',
  'sortKey',
  'title',
  'dateStart',
  'dateEnd',
  'ongoing',
  'hideDays',
  'hideMonths',
]

export const queryProjectEntryBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'en-US',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: fields,
      populate: {
        ...queryFragmentSeo,
        ...queryFragmentBlocks,
        ...queryFragmentCalendarEntries,
        ...queryFragmentBulletinBoardEntries,
        ...queryFragmentCommunityEntries,
        ...queryFragmentMapRepresentation,
        childProjectEntries: {
          fields: [
            'title',
            'slug',
            'locale',
            'dateStart',
            'dateEnd',
            'ongoing',
            'hideDays',
            'hideMonths',
          ],
          populate: {
            localizations: {
              fields: [
                'title',
                'slug',
                'locale',
                'dateStart',
                'dateEnd',
                'ongoing',
                'hideDays',
                'hideMonths',
              ],
            },
            coverImage: '*',
            projectCategories: {
              fields: ['label']
            },
          },
        },
        parentProjectEntry: {
          fields: [
            'title',
            'slug',
            'locale',
            'dateStart',
            'dateEnd',
            'ongoing',
            'hideDays',
            'hideMonths',
          ],
          populate: {
            localizations: {
              fields: [
                'title',
                'slug',
                'locale',
                'dateStart',
                'dateEnd',
                'ongoing',
                'hideDays',
                'hideMonths',
              ],
            },
            coverImage: '*',
            projectCategories: {
              fields: ['label']
            },
          }
        },
        localizations: {
          fields: fields
        },
        projectAreas: {
          fields: ['label']
        },
        projectCategories: {
          fields: ['label']
        },
        secondaryTitles: {
          fields: ['value']
        },
        coverImage: '*'
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `project-entries?${query}`
}
